// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3hgC6","log":"ModalInventoryLogs_log__kmNvM","date":"ModalInventoryLogs_date__XVl0T","userName":"ModalInventoryLogs_userName__32hdF"};